module.exports = __webpack_public_path__ + "img/icon_map_7_off_001.35494eec.png";